import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {EVENT_NAME, LOCAL_STORAGE} from '@utils/Const'
import {initTracking, trackingEvent} from '@utils'

const initialState = {
  topic_id: '',
  topic_name: '',
  part_name: '',
  lesson_id: '',
  lesson_name: '',
  entry_point: '',
}

export const mixpanelSlide = createSlice({
  name: 'mixpanel',
  initialState,
  reducers: {
    clickTopic: (state: any, action) => {
      trackingEvent(EVENT_NAME.CLICK_TOPIC, {
        topic_id: action?.payload?.topic_id,
        topic_name: action?.payload?.topic_name,
        part_name: action?.payload?.part_name,
        entry_point: action?.payload?.entry_point,
      })
      state.topic_id = action?.payload?.topic_id
      state.topic_name = action?.payload?.topic_name
      state.part_name = action?.payload?.part_name
      state.entry_point = action?.payload?.entry_point
    },
    clickLesson: (state: any, action) => {
      trackingEvent(EVENT_NAME.CLICK_LESSON, {
        topic_id: state?.topic_id,
        topic_name: state?.topic_name,
        part_name: state?.part_name,
        lesson_id: action?.payload?.lesson_id,
        lesson_name: action?.payload?.lesson_name,
      })
      state.lesson_id = action?.payload?.lesson_id
      state.lesson_name = action?.payload?.lesson_name
    },
    clickEndConverstation: (state: any, action: any) => {
      trackingEvent(EVENT_NAME.CLICK_END, {
        topic_id: state?.topic_id,
        topic_name: state?.topic_name,
        part_name: state?.part_name,
        lesson_id: state?.lesson_id,
        lesson_name: state?.lesson_name,
      })
    },
    trackingProgressConverstation: (state: any, action: any) => {
      trackingEvent(action?.payload, {
        topic_id: state?.topic_id,
        topic_name: state?.topic_name,
        part_name: state?.part_name,
        lesson_id: state?.lesson_id,
        lesson_name: state?.lesson_name,
      })
    },
  },
})

export const {
  clickTopic,
  clickLesson,
  trackingProgressConverstation,
  clickEndConverstation,
} = mixpanelSlide.actions
export default mixpanelSlide.reducer
